import { all, call } from 'redux-saga/effects';

import accountSagas from './account/accountSagas';
import assetSagas from './asset/assetSagas';
import baremetalSagas from './baremetal/sagas';
import billingSagas from './billing/billingSagas';
import contactSagas from './contact/contactSagas';
import marketSagas from './market/sagas';
import networkSagas from './network/networkSagas';
import productSagas from './product/productSagas';
import projectSagas from './project/projectSagas';
import serverSagas from './server/serverSagas';
import sslCertificateSagas from './ssl/certificate/sslCertificateSagas';
import stormSagas from './storm/stormSagas';
import usertaskSagas from './usertask/usertaskSagas';
import utilitiesSagas from './utilities/utilitiesSagas';

export default function* apiRootSagas() {
	yield all([
		call(accountSagas),
		call(assetSagas),
		call(baremetalSagas),
		call(billingSagas),
		call(contactSagas),
		call(marketSagas),
		call(networkSagas),
		call(productSagas),
		call(projectSagas),
		call(serverSagas),
		call(sslCertificateSagas),
		call(stormSagas),
		call(usertaskSagas),
		call(utilitiesSagas),
	]);
}
